export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const REPORT_AI_BASE_URL = process.env.REACT_APP_REPORT_AI_SERVICE_URL;
const BASE_PATH =  '/forms/api';
const COCKPIT_PATH = '/cockpit/api';

const API_ROUTES = {
  FORMS: {
    CREATEFORM: BASE_PATH + "/forms",
    LISTFORMS: BASE_PATH + "/forms?pageNumber=<pageNumber>&pageSize=<pageSize>&key=<key>&sort=<sort>",
    UPDATEFORM: BASE_PATH + "/forms/<formId>",
    SHAREFORM: BASE_PATH + "/forms/<formId>/share?token=<token>",
    SHAREDWITH: BASE_PATH + "/forms/<formId>/share?token=<token>",
    GET_SHARED_DETAILS: COCKPIT_PATH + "/open/assessment-forms/share/<token>",
    SHARED_WITH_FOR_OPEN_FORM: BASE_PATH + "/open-view/forms/<formId>/share/<token>",
    SHARE_OPEN_FORM: BASE_PATH + "/open-view/forms/<formId>/share/<token>",
    GET_SKELETON_FOR_REVIEW: BASE_PATH + "/open-view/forms-review/<token>/preview",
    GET_SUBMITTED_DATA_FOR_REVIEW: BASE_PATH + "/open-view/forms-review/<token>/form-data",
    APPROVE_FORM_SUBMISSION: BASE_PATH + "/open-view/forms-review/<token>/approve",
    REJECT_FORM_SUBMISSION: BASE_PATH + "/open-view/forms-review/<token>/reject",
  },
  UTILS: {
    LANGUAGE: BASE_PATH + "/languages?key=<ln>",
    GET_UNITS_OF_MEASURE: BASE_PATH + "/util/units?companyId=<companyId>",
  },
  EDITFORM: {
    GETFORM: BASE_PATH + "/forms/<formId>",
    GETSUBMITFORMDETAILS: BASE_PATH + "/preview?key=<tokenkey>&languageId=<languageId>",
    GETSECTION: BASE_PATH + "/forms/<formId>/sections/<sectionId>",
    SECTIONCREATE: BASE_PATH + "/forms/<formId>/sections",
    FIELDCREATE: BASE_PATH + "/forms/<formId>/sections/<sectionId>/fields",
    FIELDCREATENOSECTION: BASE_PATH + "/forms/<formId>/fields",
    PUBLISHFORM: BASE_PATH + "/forms/<formId>/status/publish",
    SUBMITFORM: BASE_PATH + "/open-view/forms/<tokenkey>/form-data",
    GETSUBMITTEDDATA: BASE_PATH + "/open-view/forms/<tokenkey>/form-data?submissionId=<submissionId>&languageId=<languageId>",
    GETPREVIEWFORMDATA : BASE_PATH + "/forms/<formId>/preview?no-cache=true&languageId=<languageId>",
    ACTIONS: BASE_PATH + '/forms/<formId>/fields/<fieldId>/actions',
    UPLOADFILE : BASE_PATH + '/open-view/forms/<tokenkey>/form-data/file-upload',
    ALLSECTIONS: BASE_PATH + "/forms/<formId>/children?languageId=<languageId>&type=all",
    GET_FORM_FIELD_LOGICS: BASE_PATH + "/forms/<formId>/fields/<fieldId>/logics?sectionId=<sectionId>",
    SAVE_FORM_FIELD_LOGICS: BASE_PATH + "/forms/<formId>/fields/<fieldId>/logics?sectionId=<sectionId>",
    REORDER_FIELD: BASE_PATH + "/forms/<formId>/fields/<fieldId>",
    REORDER_SECTION: BASE_PATH + "/forms/<formId>/sections/<sectionId>",
    DELETEFIELD: BASE_PATH + "/forms/<formId>/fields/<fieldId>?sectionId=<sectionId>",
    DELETESECTION: BASE_PATH + "/forms/<formId>/sections/<sectionId>?deleteChildren=<boolChildren>",
    GETSHAREDFORMDETAILS: BASE_PATH + "/forms/<formId>/share?token=<token>",
    DELETE_DISPLAY_LOGIC:  BASE_PATH + "/forms/<formId>/fields/<fieldId>/logics/<logicId>",
    GETFIELD: BASE_PATH + "/forms/<formId>/fields/<fieldId>",
    GETFIELD_WITH_SECTION: BASE_PATH + "/forms/<formId>/sections/<sectionId>/fields/<fieldId>",
  },
  USER: {
    GETUSERDETAILS: BASE_PATH + "/account"
  },
  TENANT: {
    LIST_COMPANY_BRANCHES: BASE_PATH + "/tenant/<tenantId>/companies/<companyId>/external-field/branches",
    LOGO: BASE_URL + COCKPIT_PATH + "/companies/<companyId>/logo-download"
  },
  REVIEW_COMMENT: {
    GET_WITH_REVIEW_TOKEN: BASE_PATH + "/open-view/forms-review/<token>/comments",
    GET_WITH_FORM_ACCESS_TOKEN: BASE_PATH + "/open-view/forms/<token>/review-comment",
    SAVE:  BASE_PATH + "/open-view/forms-review/<token>/response/<responseId>/comment",
    SAVE_FOR_DATA_OWNER: BASE_PATH + "/open-view/forms/<token>/response/<responseId>/comment",
  },
  CARBON_EMISSION: {
    GET_EMISSIONS: BASE_URL + COCKPIT_PATH + "/emission/calculator?scope=<scope>&category=<category>&db=<db>&period=<period>&businessUnitId=<businessUnitId>",
    GET_CATS: BASE_URL + COCKPIT_PATH + "/emission/calculator/category/scope/<scope>",
    GET_LEVELS: BASE_URL + COCKPIT_PATH + "/emission/calculator/level/db/<db>/scope/<scope>?category=<category>&level=<level>&level1=<level1>&level2=<level2>&level3=<level3>&level4=<level4>&level5=<level5>",
    GET_UOM: BASE_URL + COCKPIT_PATH + "/emission/calculator/uom/db/<db>/scope/<scope>?level1=<level1>&level2=<level2>&level3=<level3>&level4=<level4>&level5=<level5>",
    GET_LIVE_DATA: BASE_URL + COCKPIT_PATH + "/emission/calculator/live/data",
    CAPTURE: BASE_URL + COCKPIT_PATH + "/emission/calculator",
    GET_CATEGORIZED_EMISSIONS: BASE_URL + COCKPIT_PATH + "/emission/calculator/category/data?db=<db>&period=<period>&ghgUnit=<ghgUnit>&businessUnitId=<businessUnitId>",
    GET_GHG: BASE_URL + COCKPIT_PATH + "/emission/calculator/ghg/unit",
    GET_DB: BASE_URL + COCKPIT_PATH + "/emission/calculator/db"
  },
  FILE: {
    DONWLOAD_BY_TOKEN : BASE_PATH + '/open-view/forms/<tokenkey>/form-data/file/<id>/download',
    DOWNLOAD_BY_SUBMISSION : BASE_PATH + '/forms/0/form-data/<submissionId>/file/<id>/download',
    DOWNLOAD_BY_REVIEW_TOKEN: BASE_PATH + '/open-view/forms-review/<tokenkey>/form-data/file/<id>/download',
    UPDATE_METADATA : BASE_PATH + '/open-view/forms/<token>/form-data/form-data/file/<id>/metadata',
    DELETE_BY_TOKEN: BASE_PATH + '/open-view/forms/<tokenkey>/form-data/file/<id>',
  },
  OCR: {
    GET_OCR_DATA:  "/ocr/extract_with_progress",
    GET_OCR_PROGRESS: "/ocr/progress/<jobId>",
  }
};
export default API_ROUTES;
